import { sanitizeHostname } from 'shared/utils/sanitize-hostname'

/**
 * Checks whether a hostname refers to a local development environment.
 *
 * The function accepts hostnames with optional ports or path segments and covers:
 *   - Standard localhost forms (e.g. `localhost`, `localhost:3000`).
 *   - Loopback IPv4 addresses (`127.x.x.x`), including variants with a port.
 *   - Common local placeholders (`0.0.0.0`) and IPv6 loopback (`::1`, `[::1]`).
 *
 * @param hostname candidate hostname to inspect
 * @returns true when the hostname should be considered local; otherwise false
 */
export const isLocalNetworkHostname = (hostname: string): boolean => {
  const trimmed = (hostname || '').trim().toLowerCase()

  if (!trimmed) {
    return false
  }

  if (trimmed === '::1' || trimmed === '[::1]') {
    return true
  }

  const normalized = sanitizeHostname(trimmed, { toLowerCase: true })

  if (!normalized) {
    return false
  }

  if (normalized === 'localhost' || normalized === '0.0.0.0') {
    return true
  }

  if (normalized.startsWith('127.')) {
    return true
  }

  return false
}
